import {
    Box,
    Card,
    CardContent,
    Paper,
    Rating,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import BookInfoCard from "shared/components/bookInfoCard";
import {toastMessage} from "shared/components/toast";
import {getBookDetailsService, getBookPagesService} from "shared/services/general";
import styles from "./style.module.scss";
import {useSelector} from "react-redux";
import {getRecentHistoryBookReviewer} from "shared/services/bookReviewerService";
import {
    approveBookAudioService,
    approveBookService,
    changeBookAudioStatusService,
    changeBookStatusService,
    getBookHistoryService, publishBookService, sendBackRevisionService
} from "shared/services/hodService";
import moment from "moment";
import CheckIcon from "@mui/icons-material/Check";
import PaginationComponent from "shared/components/pagination";
import SkeletonLoader from "./skeletonLoader";
// import { LastPage } from "@mui/icons-material";
import {Icons} from "assets";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import {routeConstant} from "shared/routes/routesConstant";
import {rolesRoutes} from "shared/routes/allRoutes";
import {getRevisionHistoryByProductManager} from "shared/services/productManagerService";
import {bookStatusEnum, roles} from "shared/utils/constants";
import {number} from "yup";
import CustomButton from "../../shared/components/customButton";
import RejectBook from "../../shared/modals/rejectBook";
import RejectBookAudioRevision from "../../shared/modals/rejectBookAudioRevision";
import classNames from "classnames";
import Confirmation from "../../shared/modals/confirmation";

function BookAudioRevisions() {
    const {id} = useParams<{ id: string }>() as { id: string };
    const {user} = useSelector((state: any) => state.root);
    const [bookDetail, setBookDetail] = useState<any>(null);
    const [bookPages, setBookPages] = useState<any>(null);
    const [bookDetailLoader, setBookDetailLoader] = useState<boolean>(false);
    const [history, setHistory] = useState<any>(null);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(1);
    const [loader, setLoader] = useState<boolean>(false);
    const [openReject, setOpenReject] = useState<boolean>(false);
    const [openConfirm, setOpenConfirm] = useState<boolean>(false);
    const [confirmCheck, setConfirmCheck] = useState<any>(null);
    const [actionLoader, setActionLoader] = useState<boolean>(false);
    const navigate = useNavigate();


    const getBookHistory = () => {
        setLoader(true);

        let service =
            Number(user?.role?.role_id) === roles.bookReviewer
                ? getRecentHistoryBookReviewer
                : Number(user?.role?.role_id) === roles.productManager
                    ? getRevisionHistoryByProductManager
                    : getBookHistoryService;

        service(bookDetail ? bookDetail?.id : null, activePage)
            .then(({data}) => {
                setHistory(data?.data?.data);
                setTotalPage(data?.data?.last_page);
                setLoader(false);
            })
            .catch((error) => {
                toastMessage("error", error?.response?.data?.message);
                console.log("error", error?.response?.data?.message);
                setLoader(false);
            });
    };

    useEffect(() => {
        if (bookDetail) {
            getBookHistory();
            getBookPagesService(bookDetail.code)
                .then(({data}) => {
                    setBookPages(data?.data?.pages);
                    setBookDetailLoader(false);
                })
                .catch((err) => {
                    toastMessage("error", err?.response?.data?.message);
                    console.log("err", err?.response?.data?.message);
                    setBookDetailLoader(false);
                });
            if(bookDetail.audio_status === 0){
                changeStatus();
            }
        }
        // eslint-disable-next-line
    }, [bookDetail, activePage]);

    const getBookDetails = () => {
        setBookDetailLoader(true);
        getBookDetailsService(id)
            .then(({data}) => {
                setBookDetail(data?.data);
                setBookDetailLoader(false);
            })
            .catch((err) => {
                toastMessage("error", err?.response?.data?.message);
                console.log("err", err?.response?.data?.message);
                setBookDetailLoader(false);
            });
    };

    useEffect(() => {
        getBookDetails();
        // eslint-disable-next-line
    }, [id]);



    const changeStatus = () => {
        changeBookAudioStatusService({ book_id: id, status: 1 })
            .then(({ data }) => {})
            .catch((err) => {
                toastMessage("error", err?.response?.data?.message);
                console.log("err", err?.response?.data?.message);
            });
    };

    useBreadcrumbs(
        {
            title: "Book Audio Revision",
            path: routeConstant.bookAudioRevisions.path.replace(":id", id),
        },
        true
    );

    const handleRejection = () => {
            setOpenReject(true);
    };


    const handleConfirmOpen = (label: string, check: string) => {
            setOpenConfirm(true);
            setConfirmCheck({
                label: label,
                check: check,
            });
    };


    const handleConfirmClose = () => {
        setOpenConfirm(false);
        setConfirmCheck(null);
    };
    const handleActions = () => {
        let resp: any = {
            book_id: bookDetail?.id,
        };


        const service =
            confirmCheck?.check === "approve"
                ? approveBookAudioService
                : confirmCheck?.check === "revision"
                    ? sendBackRevisionService
                    : confirmCheck?.check === "publish"
                        ? publishBookService
                        : null;

        if (!service) return;

        setActionLoader(true);
        service(resp)
            .then(({ data }) => {
                toastMessage("success", data?.message);
                setActionLoader(false);
                navigate(routeConstant.dashboard.path);
            })
            .catch((err) => {
                toastMessage("error", err?.response?.data?.message);
                console.log("err", err?.response?.data?.message);
                setActionLoader(false);
            });
    };

    return (
        <div>
            <Card>
                <CardContent>
                    <BookInfoCard book={bookDetail} loader={bookDetailLoader}/>

                    {bookPages && bookPages.map((page: any, index: number) => {
                        return <AudioComponent page={page} book={bookDetail} pageNumber={index + 1} key={index}/>
                    })}
                    {(bookDetail?.audio_status === bookStatusEnum.pending || bookDetail?.audio_status === bookStatusEnum.admin_review) && (
                    <div className={styles.btnContainer}>
                        <CustomButton
                            text="Reject"
                            buttonStyle={styles.btnCustom}
                            handleClick={
                                () => handleRejection()}
                        />
                        <CustomButton
                            text="Approve"
                            buttonStyle={classNames(
                                styles.btnCustom,
                                styles.approveBtn
                            )}
                            handleClick={() =>
                                handleConfirmOpen(
                                    "Are you sure, you want to approve?",
                                    "approve"
                                )
                            }
                        />
                    </div>
                    )}
                </CardContent>
            </Card>

            <RejectBookAudioRevision
                open={openReject}
                handleClose={() => setOpenReject(false)}
                selectedBook={bookDetail}
                isRating
            />

            <Confirmation
                open={openConfirm}
                handleClose={handleConfirmClose}
                text={confirmCheck?.label}
                handleClick={handleActions}
                loader={actionLoader}
            />
        </div>
    );
}

interface AudioComponentProps {
    page: any,
    book: any,
    pageNumber: number
}

const pauseAllOtherAudio = (currentAudio?: HTMLAudioElement) => {
    document.querySelectorAll("audio").forEach((audio) => {
        if (audio !== currentAudio && !audio.paused) {
            audio.pause();
        }
    });
    if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel();
    }
};

const AudioComponent = ({page, book, pageNumber}: AudioComponentProps) => {
    const [audioText, setAudioText] = useState(page.audio_text);
    const [audioUrl, setAudioUrl] = useState(page.audio_path);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const audioRef = useRef<HTMLAudioElement>(null);

    useEffect(() => {
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const handlePlay = () => {
            pauseAllOtherAudio(audioEl);
        };
        audioEl.addEventListener("play", handlePlay);
        return () => {
            audioEl.removeEventListener("play", handlePlay);
        };
    }, []);

    const handleGenerateSpeech = () => {
        if (window.speechSynthesis.speaking) {
            window.speechSynthesis.cancel();
            setIsSpeaking(false);
        } else {
            pauseAllOtherAudio();
            const utterance = new SpeechSynthesisUtterance(audioText);
            utterance.onend = () => setIsSpeaking(false);
            window.speechSynthesis.speak(utterance);
            setIsSpeaking(true);
        }
    };
    return (
        <div className={styles.audioItem}>
            <div className={styles.audioItemInner}>
                <div className={styles.pageLabel}>Page {pageNumber}</div>
                <div className={styles.audioRow}>
                    <div className={styles.imageWrap}>
                        <img src={page.page_path} alt={`Page ${pageNumber}`}/>
                    </div>
                    <div className={styles.contentWrap}>
                        {book?.audio_type === 'manual' ? (
                            <div className="audio-preview mt-4">
                                <audio ref={audioRef} controls style={{width: '100%'}}
                                       src={audioUrl} className="w-100">Your browser does not support the audio element.
                                </audio>
                            </div>
                          ) : (<>
              <textarea style={{width: '100%'}}
                  className={styles.textarea}
                  id="description"
                  name="description"
                  value={audioText}
                  disabled={true}
              />
              {book?.audio_type === 'ai' && (
                <div style={{width: '100%', display: 'flex', justifyContent: 'end', paddingTop: '10px'}} >
                        <CustomButton
                            text={isSpeaking ? "Stop Audio" : "Play Audio"}
                            buttonStyle={styles.btnPlayCustom}
                            handleClick={
                                () => handleGenerateSpeech()}
                        />
                            </div>
                            )}

                        </>)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookAudioRevisions;
